import React from "react";
import SummaryTableAccordion from "./SummaryTableAccordion";

interface SummaryTableProps {
  title: string;
  accordionsList: any[];
  estimatedTitle?: string;
}

const SummaryTable: React.FC<SummaryTableProps> = ({
  title,
  accordionsList,
  estimatedTitle = "Estimated",
}) => {
  return (
    <div className="flex flex-col min-w-0 p-4 bg-gray-100 rounded-lg">
      {/* Table Header */}
      <div className="flex min-w-0 flex-row">
        <div className="flex-[6]">
          <table className="table-auto w-full">
            <thead>
              <tr>
                <th className="p-2 h-12 text-left text-black text-sm bg-gray-100 text-purple-800 text-xl">
                  {title}
                </th>
              </tr>
            </thead>
          </table>
        </div>

        <div className="flex-[4]">
          <table className="table-auto w-full">
            <thead>
              <tr className="flex min-w-0">
                <th
                  className={`flex-[3] p-2 h-12 text-left flex items-center align-end justify-center text-white text-m ${
                    estimatedTitle === "Forecast"
                      ? "bg-[linear-gradient(to_top_right,_var(--tw-gradient-stops))] from-custom-teal to-custom-dark-purple via-custom-purple"
                      : "bg-[#6D53FD]"
                  }`}
                >
                  {estimatedTitle}
                </th>
                <th className="flex-[3] p-2 h-12 text-left flex items-center align-end justify-center text-white text-m bg-[#19AEDE]">
                  Actual
                </th>
                <th className="flex-[3] p-2 h-12 text-left bg-white text-black text-m text-center">
                  Difference
                </th>
                <th className="flex-[1] p-2 h-12 bg-white"></th>
              </tr>
            </thead>
          </table>
        </div>
      </div>

      {/* Accordions */}
      {accordionsList.map((accordion, index) => (
        <SummaryTableAccordion
          key={index}
          headerTitle={accordion.headerTitle}
          estimated={accordion.estimated}
          estimatedTitle={accordion.estimatedTitle}
          actual={accordion.actual}
          difference={accordion.difference}
          calculatedData={accordion.calculatedData}
        />
      ))}
    </div>
  );
};

export default SummaryTable;
